import React, { useEffect, useRef } from "react";

// Logo en 3D (épaisseur par couches empilées) qui fait un tour complet (360°) quand on fait défiler la page.
// Reste en fond, ne gêne pas la lecture ni les clics.
export default function LogoSpin3D({ src, opacity = 0.16, size = "min(72vh, 78vw)", z = -1, blend = "normal", degPerPx = 0.2, layers = 9 }) {
  const rot = useRef(null);
  useEffect(() => {
    const el = rot.current;
    if (!el) return undefined;
    const reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let target = 0, cur = 0, raf;
    const read = () => { target = (window.scrollY || document.documentElement.scrollTop || 0) * degPerPx; };
    const tick = () => {
      cur += (target - cur) * 0.12;
      if (Math.abs(target - cur) < 0.05) cur = target;
      const tilt = 8 + 4 * Math.sin((cur * Math.PI) / 180);
      el.style.transform = `rotateX(${tilt}deg) rotateY(${reduce ? 20 : cur}deg)`;
      raf = requestAnimationFrame(tick);
    };
    read();
    cur = target;
    window.addEventListener("scroll", read, { passive: true });
    raf = requestAnimationFrame(tick);
    return () => { window.removeEventListener("scroll", read); cancelAnimationFrame(raf); };
  }, [degPerPx]);

  const half = (layers - 1) / 2;
  return (
    <div aria-hidden="true" data-testid="logo-spin-3d" style={{ position: "fixed", inset: 0, zIndex: z, pointerEvents: "none", display: "flex", alignItems: "center", justifyContent: "center", perspective: "1500px", opacity, mixBlendMode: blend }}>
      <div ref={rot} style={{ width: size, height: size, position: "relative", transformStyle: "preserve-3d", willChange: "transform" }}>
        {Array.from({ length: layers }).map((_, i) => {
          const d = i - half;
          const mid = Math.abs(d) < 0.01;
          return (
            <img key={i} src={src} alt="" draggable={false}
              style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "contain", transform: `translateZ(${d * 5}px)`, filter: mid ? "none" : `brightness(${0.75 + 0.2 * (1 - Math.abs(d) / half)})`, backfaceVisibility: "visible" }} />
          );
        })}
      </div>
    </div>
  );
}
